








import { Vue, Component, Prop, Watch } from "vue-property-decorator";
@Component
export default class CBox extends Vue {
  val = false;

  @Prop({ type: Function, default: () => null })
  readonly returnValue!: () => void;

  @Prop({ type: Boolean, default: false })
  readonly value!: boolean;

  @Watch("value")
  valueWatcher(value: boolean) {
    this.val = value;
  }

  mounted() {
    this.val = this.value;
  }
}
